import { Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { CalendarEvent } from 'src/meetings/models';

type Props = {
  event: CalendarEvent;
};

export const SummaryTab = ({ event }: Props) => {
  return (
    <Stack gap="xs">
      <Text size="md" fw={FONT_WEIGHTS.semibold} c="gray.10">
        Overview
      </Text>
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {event.summary ?? 'No summary available'}
      </Text>
    </Stack>
  );
};
